module.exports = __webpack_public_path__ + "fo.76d76579.svg";